
















import { defineComponent, ref, nextTick } from 'vue-demi';
import SearchBoxVue from './search-box.vue';
import SearchHistoryVue from './search-history.vue';
import { useSearchHistory } from './use-search-history';

export default defineComponent({
  components: {
    SearchBoxVue,
    SearchHistoryVue,
  },
  emits: ['cancel', 'search', 'clear'],
  props: {
    keyStr: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const searchHistory = useSearchHistory();

    const isShowHistory = ref(!props.keyStr);
    const hisKeyword = ref(props.keyStr);

    function eSearchHis(str: string) {
      if (str === hisKeyword.value) {
        hisKeyword.value = '';
      }
      nextTick(() => {
        hisKeyword.value = str;
      });
      eSearch(str);
    }

    function eSearch(str: string) {
      emit('search', str);
      isShowHistory.value = false;
      searchHistory.setHistory(str);
    }
    function eCancel() {
      emit('cancel');
    }
    function eClear() {
      emit('clear');
      isShowHistory.value = true;
    }
    return {
      isShowHistory,
      hisKeyword,

      eSearch,
      eSearchHis,
      eCancel,
      eClear,
    };
  },
});
